// npm dependeces
import 'jquery';
import 'bootstrap';
import 'jquery-match-height';
import FastClick from 'fastclick';

// common的なjs
import closeNav from './common/closeNav';
import fontLoader from './common/fontLoader';
import getMailform from './common/getMailform';
import japaneseLineBreak from './common/japaneseLineBreak';
import mouseWheelScroll from './common/mouseWheelScroll';
import odometerAction from './common/odometerAction';
import onFocusBlur from './common/onFocusBlur';
import preloader from './common/preloader';
import scrollAnimation from './common/scrollAnimation';
import scrollSpyCtrl from './common/scrollSpyCtrl';
import shopListCtrl from './common/shopListCtrl';
import smoothScroll from './common/smoothScroll';

// iOS のブラウザバック時のキャッシュ対策
window.onpageshow = (evt) => { if (evt.persisted) { location.reload(); } };
// Webフォント読み込み
fontLoader();

$(() => {
  FastClick.attach(document.body); // FastClickを有効化
  closeNav();
  getMailform();
  japaneseLineBreak();
  mouseWheelScroll();
  odometerAction();
  onFocusBlur();
  scrollAnimation();
  scrollSpyCtrl();
  shopListCtrl();
  smoothScroll();
  preloader();
});



// WEBPACK FOOTER //
// ./src/scripts/main.js